import Sentry from 'sentry';

global.UNFA = {
    // Wurde Popup mit Altershinweis schon gezeigt:
    age_hint: false,
    branch: 'unfa',
    // Liste der Beiträge pro VP:
    btr: {},
    current_vp: 1,
    divtop: 0,
    // 0 = ohne Dauernachlass, 1 = mit Dauernachlass 3 Jahre
    dnls: 0,
    // dry-run marker:
    dry: true,
    o_possible: false,
    // 0 fuer Premium, 1 fuer PremiumPlus
    plus: 0,
    // Aktueller Screen bei mobile
    screen: 0,
    // Berufe-ID, Beruf und GG der VP
    vp_gg: {},
    // Nummer für VP
    vp_id: 0,
    // dict der VPs in Unfall:
    vps: {},
    vps_count: 0,
    // UV-Type: 'unfa' = normal, 'unfa1' = Sonderkonzept, 'unfa2 = Unfall neu (01.10.2019)
    type: 'unfa',

    add_globals: function (data) {
        // Erweitere serialisiertes VP-Objekt um
        // für alle VPs geltende Parameter
        var _plus = 0;
        if (JQ('#f_' + UNFA.type + '_plus_1').length && JQ('#f_' + UNFA.type + '_plus_1').is(':checked')) _plus = 1;
        else if (JQ('#f_' + UNFA.type + '_plus').length && JQ('#f_' + UNFA.type + '_plus').is(':checked')) _plus = 1;
        data.push(
            {name: 'sid', value: JQ('#f_sid').val()},
            {name: 'branch', value: UNFA.type},
            {name: UNFA.type + '_plus', value: _plus},
            {name: UNFA.type + '_dnls', value: JQ('#f_' + UNFA.type + '_dnls').is(':checked') ? 1 : 0},
            {name: UNFA.type + '_esg', value: JQ('#f_' + UNFA.type + '_esg').is(':checked') ? 1 : 0},
            {name: 'rbt_' + UNFA.type, value: JQ('#f_rbt_' + UNFA.type).val()},
            {name: 'rbt_' + UNFA.type + 'xf', value: JQ('#f_rbt_' + UNFA.type + 'xf').is(':checked') ? 1 : 0},
            {name: UNFA.type + '_start', value: JQ('#f_' + UNFA.type + '_start').val()},
            {name: UNFA.type + '_ende', value: JQ('#f_' + UNFA.type + '_ende').val()},
            {name: UNFA.type + '_mwa', value: UNFA.get_mwa()},
            {name: UNFA.type + '_zw', value: JQ('#f_' + UNFA.type + '_zw').val()},
            {name: UNFA.type + '_rbt_bundle', value: JQ('#f_' + UNFA.type + '_rbt_bundle').val()},
            {name: UNFA.type + '_integralfranchise', value: JQ('#f_' + UNFA.type + '_integralfranchise_1').is(':checked') ? 1 : 0},
            {name: UNFA.type + '_dynamik', value: JQ('[name=' + UNFA.type + '_dynamik]').val()},
            {name: UNFA.type + '_rbt_bundle_text', value: JQ('#f_' + UNFA.type + '_rbt_bundle_text').val()});
    },

    addVP: function (versicherungsPerson) {

        var ids = [];
        JQ('#tbody_' + UNFA.type + '_vps').find('tr').each(function (i, e) {
            ids.push(parseInt(JQ(e).attr('data-vp-id')));
        });

        // Berechne Prämie nach Zahlungsweise für diese VP
        // Wenn dry=true, wird nur die Prämie berechnet, das Fenster bleibt offen,
        // bei dry=false wird das Fenster geschlossen und die berechnete
        // VP der Liste vps angefügt.
        BC.debug('UNFA.addVP() dry for ' + UNFA.type, [UNFA.dry, this], 64);
        var i = UNFA.type + '_vp_';
        if (UNFA.canCalc()) {

            // Prämie berechnen via JSON
            // Geliefertes Ergebnis-Snippet in Tabelle einfügen
            if (!UNFA.dry && JQ('#f_' + UNFA.type + '_todo').val() == 'add') {
                BC.debug('UNFA.addVP() NOT dry for ' + UNFA.type, this, 64);
                if (ids.length !== 0) {
                    UNFA.vp_id = ids.reduce(function (a, b) {
                        return Math.max(a, b);
                    }) + 1;
                } else {
                    UNFA.vp_id = 1;
                }

                if (versicherungsPerson) {
                    JQ('[data-vp-name]').val(versicherungsPerson.vp_id);
                    JQ('#f_' + UNFA.type + '_vp_id').val(versicherungsPerson.vp_id);
                } else {
                    JQ('#f_' + UNFA.type + '_vp_id').val(UNFA.vp_id);
                }

            } else if (!UNFA.dry && JQ('#f_' + UNFA.type + '_todo').val() == 'edit') {
                UNFA.vp_id = parseInt(JQ('#f_' + UNFA.type + '_vp_id').val());
            }

            if (versicherungsPerson) {
                i = i + versicherungsPerson.vp_id;
            } else {
                i = i + UNFA.vp_id;
            }

            JQ('#f_' + UNFA.type + '_action').val(UNFA.dry ? 'getpremvp' : 'addvp');

            var frmdata = JQ('#div_' + UNFA.type + '_add_vp :input').serializeArray();

            frmdata.push(
                {name: 'sid', value: JQ('#f_sid').val()},
                {name: UNFA.type + '_plus', value: JQ('#f_' + UNFA.type + '_plus').is(':checked') ? 1 : 0},
                {name: UNFA.type + '_dnls', value: JQ('#f_' + UNFA.type + '_dnls').is(':checked') ? 1 : 0},
                {name: UNFA.type + '_esg', value: JQ('#f_' + UNFA.type + '_esg').is(':checked') ? 1 : 0},
                {name: 'rbt_' + UNFA.type, value: JQ('#f_rbt_' + UNFA.type).val()},
                {name: 'rbt_' + UNFA.type + 'xf', value: JQ('#f_rbt_' + UNFA.type + 'xf').is(':checked') ? 1 : 0},
                {name: UNFA.type + '_start', value: JQ('#f_' + UNFA.type + '_start').val()},
                {name: UNFA.type + '_ende', value: JQ('#f_' + UNFA.type + '_ende').val()},
                {name: UNFA.type + '_mwa', value: UNFA.get_mwa()},
                {name: UNFA.type + '_rbt_bundle', value: JQ('#f_' + UNFA.type + '_rbt_bundle').val()},
                {name: UNFA.type + '_integralfranchise', value: JQ('#f_' + UNFA.type + '_integralfranchise_1').is(':checked') ? 1 : 0},
                {name: UNFA.type + '_dynamik', value: JQ('[name=' + UNFA.type + '_dynamik]').val()},
                {name: UNFA.type + '_zw', value: JQ('#f_' + UNFA.type + '_zw').val()}
            );

            BC.debug('UNFA.addVP(): frmdata => ', frmdata, 64);

            JQ.getJSON(JSONURI,
                frmdata,
                UNFA.dry ? UNFA.setFlds : UNFA.addVProw
            );

            if (!UNFA.dry && !ALL.err) {

                BC.debug('UNFA.addVP():', UNFA.vp_id, 64);

                UNFA.vps[i] = ALL.deserial(frmdata);

                JQ.each(UNFA.vps[i], function (k, v) {
                    if (k.split('_', 2).join('_') == UNFA.type + '_vp' || k == 'branch') return true;
                    //delete UNFA.vps[i][k];
                });
                JQ('#div_' + UNFA.type + '_add_vp').dialog('close');
                BC.debug('UNFA.addVP(), vps-array: ', UNFA.vps, 64);
            }
        }
    },

    addVPreal: function (versicherungsPerson) {
        UNFA.dry = false;
        if (!ALL.err) UNFA.addVP(versicherungsPerson);
        UNFA.dry = true;
    },

    addVProw: function (data) {
        if (isEsg === 1) {
            JQ('f_' + UNFA.type + '_esg').prop('checked', true)
        }
        // Fügt die versicherte Person in der Tabelle an.
        // Der Server liefert die VP in einem <tr>-template
        BC.debug('UNFA.addVProw(): todo, data',
            [JQ('#f_' + UNFA.type + '_todo').val(), data], 64);
        ALL.chkError(data);
        if (ALL.err) {
            UNFA.dry = true;
            return;
        }
        if (JQ('#f_' + UNFA.type + '_todo').val() == 'edit' &&
            JQ('#' + UNFA.type + '_vp_row_' + data.btrs.id).length) {
            JQ('#' + UNFA.type + '_vp_row_' + data.btrs.id).replaceWith(data.html);
        } else if (JQ('#f_' + UNFA.type + '_todo').val() == 'add' ||
            JQ('#f_' + UNFA.type + '_todo').val() == 'edit') {
            JQ('#tbody_' + UNFA.type + '_vps').append(data.html);
        }
        UNFA.btr[UNFA.type + '_vp_' + data.btrs.id] = data.btrs;

        var wrapper = JQ('#tbody_' + UNFA.type + '_vps');
        var children = wrapper.children('.vp-row');

        children.sort(function (a, b) {
            return +parseInt(JQ(a).attr('data-vp-id')) - parseInt(+JQ(b).attr('data-vp-id'));
        }).each(function () {
            wrapper.append(this);
        });

        UNFA.recalcPrSum();
        ALL.notifyHeight();
    },

    calc_vp: function (_vp) {
        // Ist für die VP vp eine Prämie berechenbar?
        // vp ist die Nummer der zu prüfenden VP
        // Oder 0, dann gilt das "alte" VP-Form aus inpart_unfa.tmpl zu prüfen
        // NEU: f_unfa_vp_1_inv (für die erste VP)
        // ALT: f_unfa_vp_inv
        var vp = 0;
        if (typeof (_vp) == 'object' && _vp.type == 'change') {
            vp = BC.get_id(_vp.currentTarget).split('_')[3];
        } else if (_vp && _vp != undefined) {
            vp = _vp;
        }
        BC.debug('UNFA.calc_vp(), Working with VP', vp, 64);
        var _id = UNFA.type + '_vp_' + vp;
        var prefix = '#f_' + UNFA.type + (vp ? '_vp_' + vp + '_' : '_vp_');
        var gebdat = moment(JQ(prefix + 'gebdat').val(), 'DD.MM.YYYY');

        var _inv = parseInt(JQ(prefix + 'inv').unmask());
        var _intds = false;
        if (_inv && !isNaN(_inv) && _inv < 999) {
            _intds = true;
            _inv = _inv * 1000;
        }
        if (isNaN(_inv) || !_inv || !ALL.isbetween(_inv, [25000, 350000])) {
            BC.debug('UNFA.calc_vp(): Cannot calc VP ' + vp + ', missing or false INV:', _inv, 64);
            UNFA.vps[_id]['vp_inv'] = _intds ? 100 : 100000;
            JQ(prefix + 'inv').val(UNFA.vps[_id]['vp_inv']);
            ALL.showHint('Die Invaliditätssumme war ungültig und wurde korrigiert', true);
            return false;
        } else {
            UNFA.vps[_id]['vp_inv'] = _inv;
            UNFA.vps[_id]['vp_invtype'] = parseInt(JQ(prefix + 'invtype').unmask());
        }

        var _unr = JQ(prefix + 'unr').length ? parseInt(JQ(prefix + 'unr').unmask()) : 0;
        if (_unr && !isNaN(_unr) && _unr < 99) {
            _intds = true;
            _unr = _unr * 100;
        }
        if (isNaN(_unr) || _unr < 0 || _unr > 1500) {
            BC.debug('UNFA.calc_vp(): Cannot calc VP ' + vp + ', missing or false UNR:', _unr, 64);
            UNFA.vps[_id]['vp_unr'] = _intds ? 1 : 100;
            JQ(prefix + 'unr').val(UNFA.vps[_id]['vp_unr']);
            ALL.showHint('Die zu versichernde Unfallrente war ungültig und wurde korrigiert', true);
            return false;
        } else {
            UNFA.vps[_id]['vp_unr'] = _unr;
        }

        var _tod = JQ(prefix + 'tod').length ? parseInt(JQ(prefix + 'tod').unmask()) : 0;
        if (_tod && !isNaN(_tod) && _tod < 999) {
            _intds = true;
            _tod = _tod * 1000;
        }
        if (isNaN(_tod) || _tod < 0 || _tod > 100000) {
            BC.debug('UNFA.calc_vp(): Cannot calc VP ' + vp + ', missing or false TOD:', _tod, 64);
            UNFA.vps[_id]['vp_tod'] = _intds ? 10 : 10000;
            JQ(prefix + 'tod').val(UNFA.vps[_id]['vp_tod']);
            ALL.showHint('Die Todesfallsumme war ungültig und wurde korrigiert', true);
            return false;
        } else {
            UNFA.vps[_id]['vp_tod'] = _tod;
            UNFA.vps[_id]['vp_todbeg'] = JQ('#f_' + _id + '_todbeg').val();
        }

        var _uel = JQ(prefix + 'uel').length ? parseInt(JQ(prefix + 'uel').unmask()) : 0;
        if (_uel && !isNaN(_uel) && _uel < 999) {
            _intds = true;
            _uel = _uel * 1000;
        }
        if (isNaN(_uel) || _uel < 0 || _uel > 15000) {
            BC.debug('UNFA.calc_vp(): Cannot calc VP ' + vp + ', missing or false UEL:', _uel, 64);
            UNFA.vps[_id]['vp_uel'] = _intds ? 5 : 5000;
            JQ(prefix + 'uel').val(UNFA.vps[_id]['vp_uel']);
            ALL.showHint('Die Übergangsleistung war ungültig und wurde korrigiert', true);
            return false;
        } else {
            UNFA.vps[_id]['vp_uel'] = _uel;
        }

        var _kht = JQ(prefix + 'kht').length ? parseInt(JQ(prefix + 'kht').unmask()) : 0;
        if (isNaN(_kht) || _kht < 0 || _kht > 50) {
            BC.debug('UNFA.calc_vp(): Cannot calc VP ' + vp + ', missing or false KHT:', _kht, 64);
            UNFA.vps[_id]['vp_kht'] = 20;
            JQ(prefix + 'kht').val(UNFA.vps[_id]['vp_kht']);
            ALL.showHint('Das zu versichernde Unfallkrankenhaustagegeld war ungültig und wurde korrigiert', true);
            return false;
        } else {
            UNFA.vps[_id]['vp_kht'] = _kht;
        }

        var _kop = JQ(prefix + 'kop').length ? parseInt(JQ(prefix + 'kop').unmask()) : 0;
        if (_kop && !isNaN(_kop) && _kop < 99) _kop = _kop * 1000;
        if (isNaN(_kop) || _kop < 0 || _kop > 30000) {
            BC.debug('UNFA.calc_vp(): Cannot calc VP ' + vp + ', missing or false KOP:', _kop, 64);
            UNFA.vps[_id]['vp_kop'] = _kop;
            return false;
        } else {
            UNFA.vps[_id]['vp_kop'] = _kop;
        }

        var _cnr = JQ(prefix + 'cnr').length ? parseInt(JQ(prefix + 'cnr').unmask()) : 0;
        if (_cnr && !isNaN(_cnr) && _cnr < 99) {
            _intds = true;
            _cnr = _cnr * 1000;
        }
        if (isNaN(_cnr) || _cnr < 0 || _cnr > 10000) {
            BC.debug('UNFA.calc_vp(): Cannot calc VP ' + vp + ', missing or false CNR:', _cnr, 64);
            UNFA.vps[_id]['vp_cnr'] = _intds ? 10 : 10000;
            JQ(prefix + 'cnr').val(UNFA.vps[_id]['vp_cnr']);
            ALL.showHint('Die Sofortleistung bei Krebs war ungültig und wurde korrigiert', true);
            return false;
        } else {
            UNFA.vps[_id]['vp_cnr'] = _cnr;
        }

        var _job = JQ(prefix + 'beruf').val();
        if (!_job) {
            BC.debug('UNFA.calc_vp(): Cannot calc VP ' + vp + ', missing or false JOB:', _job, 64);
            return false;
        }
        BC.debug('UNFA.calc_vp(' + vp + '): ', '', 64);
        var vpdata = JQ('#div_' + UNFA.type + '_vp_' + vp + '_vers :input').serializeArray();
        vpdata.push({name: 'action', value: 'getpremvp'});
        UNFA.add_globals(vpdata);
        BC.debug('UNFA.calc_vp(): vpdata => ', vpdata, 64);
        JQ.getJSON(JSONURI,
            vpdata,
            UNFA.set_vp_btr
        );
    },

    canCalc: function (e) {
        // Sind alle für die Berechnung einer Prämie in Sparte x
        // benötigten Risikoangaben vorhanden?
        // Die Fehlerhinweise werden nur angezeigt, wenn UNFA.dry = false
        var valid = true;
        var t0 = moment(JQ('#f_' + UNFA.type + '_vp_gebdat').val(), 'DD.MM.YYYY');
        // t1 ist das gewünschte Beginndatum
        var t1 = moment(JQ('#f_' + UNFA.type + '_start').val(), 'DD.MM.YYYY');
        // t2 ist das früheste Beginndatum
        var t2 = moment(in2days, 'DD.MM.YYYY');
        // age ist das Alter der VP zum Versicherungsbeginn
        var age = t1.diff(t0, 'y', true);
        // XXX Build iterator over num-fields!
        var _type = parseInt(JQ('#fset_' + UNFA.type + "_add_vp input[name='" + UNFA.type + "_vp_inv_type']:checked").val());
        var _inv = parseInt(JQ('#f_' + UNFA.type + '_vp_inv').val());
        var _unr = parseInt(JQ('#f_' + UNFA.type + '_vp_unr').val());
        var _tod = parseInt(JQ('#f_' + UNFA.type + '_vp_tod').val());
        var _uel = parseInt(JQ('#f_' + UNFA.type + '_vp_uel').val());
        var _kht = parseInt(JQ('#f_' + UNFA.type + '_vp_kht').val());
        var _kop = parseInt(JQ('#f_' + UNFA.type + '_vp_kop').val());
        var _mwa = UNFA.get_mwa();
        var _cnr = parseInt(JQ('#f_' + UNFA.type + '_vp_cnr').val());
        var _kt15 = parseInt(JQ('#f_' + UNFA.type + '_vp_kt15').val());
        var _kt43 = parseInt(JQ('#f_' + UNFA.type + '_vp_kt43').val());
        var _sk = JQ("#f_" + UNFA.type + "_sk").val() == '1';
        // Dauernachlass / 3-Jahresvertrag gewählt?
        var _dnls = JQ("#f_" + UNFA.type + "_dnls").prop('checked');
        UNFA.age_hint = false;
        JQ("#f_" + UNFA.type + "_dnls").attr('disabled', false);
        BC.debug('UNFA.canCalc(): SK is ', _sk, 128);
        var _job = JQ('#f_' + UNFA.type + '_vp_beruf').val();
        if (!_job) {
            if (!UNFA.dry) ALL.showHint('Die Berufsangabe fehlt!', 1);
            BC.debug('UNFA.canCalc(): Missing f_vp_beruf', null, 64);
            valid = false;
        }
        if (!t0.isValid() || !t1.isValid()) {
            if (!UNFA.dry) ALL.showHint('Mindestens ein Datumsfeld ist ungültig!', 1);
            BC.debug('UNFA.canCalc(): t0 or t1 invalid', null, 64);
            valid = false;
        }
        if (t0 >= t1) {
            // Geburtsdatum groesser Beginndatum...:
            if (!UNFA.dry) ALL.showHint('Geburtsdatum größer als Beginndatum, bitte korrigieren!', 1);
            BC.debug('UNFA.canCalc(): t0 => t1', null, 64);
            valid = false;
        }
        if (t1 < t2 && 1 == 2) {
            // Beginndatum kleiner als obiges frühestes Beginndatum:
            if (!UNFA.dry) ALL.showHint('Beginn der Versicherung kann frühestens in zwei Tagen sein! Bitte schließen Sie dieses Unterformular, korrigieren Sie den gewünschten Versicherungsbeginn unterhalb des Reiters "VN / Kunde" und öffnen anschließend dieses Eingabeformular erneut.', 1);
            BC.debug('UNFA.canCalc(): t1 < t2', null, 64);
            valid = false;
        }
        if (age >= 75) {
            ALL.showHint('Das Höchstaufnahmealter beträgt 75 Jahre, eine Unfallversicherung ist für diese Person daher nicht möglich.', 1);
            valid = false;
        } else if (age >= 70) {
            if (!UNFA.age_hint) ALL.showHint('Für Personen, die älter als 70 sind, kann keine Progression vereinbart und weder Unfallrente, Unfallkrankenhaustagegeld oder Sofortleistung bei Krebserkrankung für eine Versicherungsdauer von mehr als einem Jahr versichert werden. Der 3-Jahresrabatt wurde entsprechend zurückgesetzt.', 1);
            UNFA.age_hint = true;
            JQ('#f_' + UNFA.type + '_vp_inv_type_500').prop({
                'disabled': true,
                'checked': false
            });
            JQ('#f_' + UNFA.type + '_vp_inv_type_350').prop({
                'disabled': true,
                'checked': false
            });
            JQ('#f_' + UNFA.type + '_vp_inv_type_225').prop({
                'disabled': true,
                'checked': false
            });
            JQ('#f_' + UNFA.type + '_vp_inv_type_100').prop({'checked': true});
            JQ('#f_' + UNFA.type + '_vp_kht').val('0').prop('disabled', true);
            JQ('#f_' + UNFA.type + '_vp_unr').val('0').prop('disabled', true);
            JQ('#f_' + UNFA.type + '_vp_cnr').val('0').prop('disabled', true);
            JQ('#f_' + UNFA.type + '_mwa_50').prop('checked', true);
            JQ('#f_' + UNFA.type + '_mwa_75').prop({'disabled': true, 'checked': false});
            JQ('#f_' + UNFA.type + '_mwa_100').prop({'disabled': true, 'checked': false});
            if (_mwa == '75' || _mwa == '100') {
                JQ('#div_' + UNFA.type + '_mwa button.btn_unfa').removeClass('active').addClass('inactive');
                JQ('#btn_' + UNFA.type + '_mwa_50').removeClass('inactive').addClass('active');
                JQ('#f_' + UNFA.type + '_mwa').val(50);
                ALL.showHint('Für diesen Vertrag sollte der Mitwirkungsanteil erhöht werden. Dies ist aufgrund des Alters der jetzt hinzuzufügenden versicherten Person aber nicht möglich. Daher wurde der Mitwirkungsanteil auf 50% reduziert. Sofern die jetzt hinzuzufügende versicherte Person in einem eigenen Vertrag (ohne Erhöhung des Mitwirkungsanteils) versichert werden soll, bitte auf "Abbrechen" klicken und den Mitwirkungsanteil für die bisher schon erfassten Personen gegebenfalls wieder erhöhen.');
            }
        } else if (age >= 68 && _dnls) {
            if (!UNFA.age_hint) ALL.showHint('Für Personen, die älter als 68 sind, kann keine Progression vereinbart und weder Unfallrente, Unfallkrankenhaustagegeld oder Sofortleistung bei Krebserkrankung für eine Versicherungsdauer von mehr als einem Jahr versichert werden. Der 3-Jahresrabatt wurde entsprechend zurückgesetzt.', 1);
            UNFA.age_hint = true;
            JQ('#f_' + UNFA.type + '_dnls').prop('disabled', true).prop('checked', false);
        } else if (age >= 66) {
            if (!UNFA.age_hint) ALL.showHint('Für Personen, die älter als 66 sind, kann keine Unfallrente, Sofortleistung bei Krebserkrankung oder eine Erhöhung des Mitwirkungsanteils versichert werden.', 1);
            UNFA.age_hint = true;
            JQ('#f_' + UNFA.type + '_vp_unr').val('0').prop('disabled', true);
            JQ('#f_' + UNFA.type + '_vp_cnr').val('0').prop('disabled', true);
            JQ('#f_' + UNFA.type + '_mwa_50').prop('checked', true);
            JQ('#f_' + UNFA.type + '_mwa_75').prop({'disabled': true, 'checked': false});
            JQ('#f_' + UNFA.type + '_mwa_100').prop({'disabled': true, 'checked': false});
            if (_mwa == '75' || _mwa == '100') {
                JQ('#div_' + UNFA.type + '_mwa button.btn_unfa').removeClass('active').addClass('inactive');
                JQ('#btn_' + UNFA.type + '_mwa_50').removeClass('inactive').addClass('active');
                JQ('#f_' + UNFA.type + '_mwa').val(50);
                ALL.showHint('Für diesen Vertrag sollte der Mitwirkungsanteil erhöht werden. Dies ist aufgrund des Alters der jetzt hinzuzufügenden versicherten Person aber nicht möglich. Daher wurde der Mitwirkungsanteil auf 50% reduziert. Sofern die jetzt hinzuzufügende versicherte Person in einem eigenen Vertrag (ohne Erhöhung des Mitwirkungsanteils) versichert werden soll, bitte auf "Abbrechen" klicken und den Mitwirkungsanteil für die bisher schon erfassten Personen gegebenfalls wieder erhöhen.');
            }
            //valid = false;
        } else if (age >= 64 && _dnls && (_unr || _cnr)) {
            if (!UNFA.age_hint) ALL.showHint('Eine Unfallrente oder die Mitversicherung der Sofortleistung bei Krebserkrankung in Kombination mit dem 3-Jahresrabatt ist für Personen, die älter als 64 sind, nicht möglich. Der 3-Jahresrabatt wurde entsprechend zurückgesetzt.', 1);
            UNFA.age_hint = true;
            JQ('#f_' + UNFA.type + '_dnls').prop('disabled', true).prop('checked', false);
        } else if (age <= 66) {
            JQ('#f_' + UNFA.type + '_vp_inv_type_500').prop('disabled', false);
            JQ('#f_' + UNFA.type + '_vp_inv_type_350').prop('disabled', false);
            JQ('#f_' + UNFA.type + '_vp_inv_type_225').prop('disabled', false);
            JQ('#f_' + UNFA.type + '_vp_kht').prop('disabled', false);
            JQ('#f_' + UNFA.type + '_vp_unr').prop('disabled', false);
            JQ('#f_' + UNFA.type + '_vp_cnr').prop('disabled', false);
        }
        if (!JQ("#fset_" + UNFA.type + "_add_vp input[name='" + UNFA.type + "_vp_inv_type']").is(':checked')) {
            if (!UNFA.dry) ALL.showHint('Ohne Auswahl einer Progressionsstufe ist eine Berechnung nicht möglich!', 1);
            BC.debug('UNFA.canCalc(): Missing f_vp_inv_type', null, 64);
            valid = false;
        }
        if (!ALL.isbetween(_inv, [25, 350])) {
            if (!UNFA.dry) ALL.showHint('Die Invaliditätssumme muss mindestens 25.000 € und kann maximal 350.000 € betragen (abhängig von der gewählten Progressionsstufe). Bitte in 1.000 € eingeben, also 25 => 25.000 €.', 1);
            BC.debug('UNFA.canCalc(): Missing f_vp_inv < 25 or f_vp_inv > 350', null, 64);
            valid = false;
        }
        if (_type == 500) {
            if (ALL.us_id == 1234) {
                JQ('#f_' + UNFA.type + '_vp_inv').prop('max', 300);
                if (_inv > 300) {
                    JQ('#f_' + UNFA.type + '_vp_inv').val(300);
                    //ALL.showHint('Bei Progression 500% beträgt die maximale VS 200.000 €!', 1);
                    ALL.showHint('Die Höchstversicherungssumme bei Progression 500% wurde überschritten!', 1);
                }
            } else {
                JQ('#f_' + UNFA.type + '_vp_inv').prop('max', 200);
                if (_inv > 200) {
                    JQ('#f_' + UNFA.type + '_vp_inv').val(200);
                    ALL.showHint('Bei Progression 500% beträgt die maximale VS 200.000 €!', 1);
                }
            }
        } else if (_type == 350) {
            JQ('#f_' + UNFA.type + '_vp_inv').prop('max', 300);
            if (_inv > 300) {
                JQ('#f_' + UNFA.type + '_vp_inv').val(300);
                ALL.showHint('Bei Progression 350% beträgt die maximale VS 300.000 €!', 1);
            }
        } else {
            JQ('#f_' + UNFA.type + '_vp_inv').prop('max', 350);
            if (_inv > 350) {
                JQ('#f_' + UNFA.type + '_vp_inv').val(350);
                ALL.showHint('Die maximale VS beträgt 350.000 €!', 1);
            }
        }
        if (!JQ("#fset_" + UNFA.type + "_add_vp input[name='" + UNFA.type + "_vp_geschl']").is(':checked')) {
            if (!UNFA.dry) {
                ALL.showHint('Bitte Geschlecht der VP angegeben.', 1);
                BC.debug('UNFA.canCalc(): Missing f_vp_geschl', null, 64);
                valid = false;
            }
        }
        if (_unr && !isNaN(_unr) && _unr > 15) {
            JQ('#f_' + UNFA.type + '_vp_unr').val(15);
            ALL.showHint('Die maximale Unfallrente beträgt 1.500 €!', 1);
        }
        if (_tod && !isNaN(_tod) && _tod > 100) {
            JQ('#f_' + UNFA.type + '_vp_tod').val(100);
            ALL.showHint('Die maximale VS für Unfalltod beträgt 100.000 €!', 1);
        } else if (_tod && !isNaN(_tod) && _tod < 5) {
            JQ('#f_' + UNFA.type + '_vp_tod').val(5);
            ALL.showHint('Die minimale VS für Unfalltod (sofern mitversichert) beträgt 5.000 €!', 1);
        }
        if (_uel && _sk && !ALL.isbetween(_uel, [1, 20])) {
            JQ('#f_' + UNFA.type + '_vp_uel').val(20);
            ALL.showHint('Die maximal versicherbare verbesserte Übergangsleistung beträgt 20.000 €!', 1);
        } else if (_uel && !_sk && !ALL.isbetween(_uel, [1, 15])) {
            JQ('#f_' + UNFA.type + '_vp_uel').val(15);
            ALL.showHint('Die maximal versicherbare verbesserte Übergangsleistung beträgt 15.000 €!', 1);
        }
        if (_kop && _sk && !ALL.isbetween(_kop, [1, 25])) {
            JQ('#f_' + UNFA.type + '_vp_kop').val(25);
            ALL.showHint('Die maximal <b>zusätzlich</b> mitversicherbaren Kosten für kosmetische OPs betragen 25.000 €!', 1);
        } else if (_kop && !ALL.isbetween(_kop, [1, 30])) {
            JQ('#f_' + UNFA.type + '_vp_kop').val(30);
            ALL.showHint('Die maximal <b>zusätzlich</b> mitversicherbaren Kosten für kosmetische OPs betragen 30.000 €!', 1);
        }
        if (_cnr && !ALL.isbetween(_cnr, [1, 10])) {
            JQ('#f_' + UNFA.type + '_vp_cnr').val(10);
            ALL.showHint('Die maximal mitversicherbare Sofortleistung bei Krebserkrankungen beträgt 10.000 €!', 1);
        }
        if (_kht && !isNaN(_kht) && _kht < 5) {
            JQ('#f_' + UNFA.type + '_vp_kht').val(5);
            ALL.showHint('Das minimale Krankenhaustagegeld beträgt 5 €.', 1);
        } else if (_kht && !isNaN(_kht) && _sk && _kht > 75) {
            JQ('#f_' + UNFA.type + '_vp_kht').val(75);
            ALL.showHint('Das maximale Unfallkrankenhaustagegeld beträgt 75 €!', 1);
        } else if (_kht && !isNaN(_kht) && _kht > 50) {
            JQ('#f_' + UNFA.type + '_vp_kht').val(50);
            ALL.showHint('Das maximale Unfallkrankenhaustagegeld beträgt 50 €!', 1);
        }
        if (_kt15 && !ALL.isbetween(_kt15, [5, 50])) {
            JQ('#f_' + UNFA.type + '_vp_kt15').val(5);
            ALL.showHint('Das maximale Unfalltagegeld ab 15. Tag beträgt 50 €, minimal 5 €.', 1);
        }
        if (_kt43 && !ALL.isbetween(_kt43, [5, 50])) {
            JQ('#f_' + UNFA.type + '_vp_kt43').val(5);
            ALL.showHint('Das maximale Unfalltagegeld ab 43. Tag beträgt 50 €, minimal 5 €!', 1);
        }
        ALL.notifyHeight();
        if (_sk) return valid;
        if (!JQ("#fset_" + UNFA.type + "_add_vp input[name='" + UNFA.type + "_vp_exriding']").is(':checked')) {
            if (!UNFA.dry) {
                ALL.showHint('Bitte auswählen, ob Unfälle beim Reitsport vom Versicherungsschutz ausgeschlossen werden sollen.', 1);
                BC.debug('UNFA.canCalc(): Missing vp_exriding', null, 64);
                valid = false;
            }
        }
        if (!JQ("#fset_" + UNFA.type + "_add_vp input[name='" + UNFA.type + "_vp_exbiking']").is(':checked')) {
            if (!UNFA.dry) {
                ALL.showHint('Bitte auswählen, ob Unfälle beim Motorradfahren vom Versicherungsschutz ausgeschlossen werden sollen.', 1);
                BC.debug('UNFA.canCalc(): Missing vp_exbiking', null, 64);
                valid = false;
            }
        }
        if (!JQ("#fset_" + UNFA.type + "_add_vp input[name='" + UNFA.type + "_vp_exskiing']").is(':checked')) {
            if (!UNFA.dry) {
                ALL.showHint('Bitte auswählen, ob Unfälle beim Skifahren vom Versicherungsschutz ausgeschlossen werden sollen.', 1);
                BC.debug('UNFA.canCalc(): Missing vp_exskiing', null, 64);
                valid = false;
            }
        }
        BC.debug('UNFA.canCalc() for ' + UNFA.type + ' returns :', valid, 64);
        PRIV.calcable = valid;
        return valid;
    },

    change: function () {
        BC.debug('UNFA.change() called', '', 64)
        // Bei Unfall kriegen wir auf screen 1 noch keine Prämie...
        // Deshalb hier forciertes Enablen des "Weiter"-Buttons
        if (UNFA.screen == 1) ALL.chgMobButtons(UNFA.type);
        var t = 'change';
        ALL.notifyHeight();
    },

    chgBtns: function (chg) {
        // Ändere Button-Beschriftung, damit bei Änderungen nicht Verwirrung entsteht...
        var _t = chg ? 'VP ändern' : 'Weiter';
        BC.debug('UNFA.chgBtns() called for ', UNFA.type, 64)
        JQ('#div_' + UNFA.type + '_add_vp').dialog('option', 'buttons',
            [{
                text: _t,
                id: UNFA.type + '_set_add_vp',
                click: function () {
                    UNFA.addVPreal()
                }
            },
                {
                    text: 'Abbrechen',
                    id: UNFA.type + '_cancel_add_vp',
                    click: function () {
                        UNFA.chk_mwa();
                        JQ(this).dialog('close');
                    }
                },
                {
                    text: 'Formular leeren',
                    id: UNFA.type + '_reset_add_vp',
                    click: function () {
                        ALL.clearForm('#div_' + UNFA.type + '_add_vp')
                    }
                },
            ]);
        if (chg) JQ('#f_' + UNFA.type + '_action').val('edit');
        else JQ('#f_' + UNFA.type + '_action').val('add');
        ALL.notifyHeight();
    },

    chgVP: function (e) {
        // Ändere / Lösche VP in Tabelle der zu versichernden Personen
        // (und im entsprechenden Array UNFA.vps)
        e.preventDefault();
        // Die "Buttons" haben id="btn_@@BRANCH@@_vp_[edit|dele]_@@_VP_ID_@@"
        // daraus ergibt sich ID und Aktion
        var _xx = e.target.id.split('_');
        var _id = parseInt(_xx.pop());
        var _do = _xx.pop();
        var _f0 = '', _f1 = '';
        UNFA.type = _xx[1];
        BC.debug('UNFA.chgVP() called for ' + _do, _xx, 64);
        if (_do == 'dele') {
            JQ('#' + UNFA.type + '_vp_row_' + _id).remove();
            delete UNFA.vps[UNFA.type + '_vp_' + _id];
            delete UNFA.btr[UNFA.type + '_vp_' + _id];
            BC.debug('UNFA.chgVP():', [_id, UNFA.vps], 128);
            UNFA.chk_mwa();
            UNFA.recalcPrSum();
        } else if (_do == 'edit') {
            // Erst einmal alle Radiobuttons, checkboxen, selected values unsetten
            JQ("#fset_" + UNFA.type + "add_vp input:radio").prop('checked', false);
            BC.debug('UNFA.chgVP(' + UNFA.type + '):', [UNFA.vps, _id, UNFA.vps[UNFA.type + '_vp_' + _id]], 64);
            JQ.each(UNFA.vps[UNFA.type + '_vp_' + _id], function (k, v) {
                BC.debug('chgVP(), edit: ', [k, v], 64);
                // _f0 ist der Feldname also z.B. "f_vp_beruf"
                _f0 = JQ('#f_' + k);
                // Radios etc. haben die folgende ID:
                // Wenn v Leerzeichen enthält, produziert jquery einen Syntax-Error!
                // Also nur den ersten Teil von v.
                if (v && !_f0.length) _f1 = JQ('#f_' + k + '_' + String(v).split(' ', 1)[0]);
                if (_f0.length) {
                    _f0.val(v);
                } else if (_f1 && _f1.length && (_f1.prop('type') == 'radio' ||
                    _f1.prop('type') == 'checkbox')) {
                    _f1.prop('checked', true);
                }
            });
            JQ('#f_' + UNFA.type + '_todo').val('edit');
            BC.debug('UNFA.chgVP(): - edit - opening dialog', UNFA.type, 128);
            JQ('#div_' + UNFA.type + '_add_vp').dialog("open");
            UNFA.chgBtns(true);
            JQ('#div_' + UNFA.type + '_add_vp').change();
            ALL.notifyHeight();
        }
    },

    chgZW: function () {
        // Berechne Prämie neu bei ZW-Änderung
        var _id = BC.get_id(this);
        BC.debug('UNFA.chgZW() - UNFA.vps', [this, _id, UNFA.type, UNFA.vps], 64);
        if (_id) UNFA.type = BC.get_id(this).split('_')[1];
        if (ALL.chkChkBox('f_' + UNFA.type + '_dnls')) ALL.chkDate(JQ('#f_' + UNFA.type + '_ende'));
        JQ('#f_' + UNFA.type + '_todo').val('edit');

        JQ.each(UNFA.vps, function (i, data) {
            if (!data || i.split('_')[0] != UNFA.type) return true;
            BC.debug('UNFA.chgZW() - i, data:', [i, data], 64);
            data.todo = 'edit';
            data[UNFA.type + '_start'] = JQ('#f_' + UNFA.type + '_start').val();
            data[UNFA.type + '_ende'] = JQ('#f_' + UNFA.type + '_ende').val();
            data[UNFA.type + '_zw'] = JQ('#f_' + UNFA.type + '_zw').val();
            data[UNFA.type + '_rbt_bundle'] = JQ('#f_' + UNFA.type + '_rbt_bundle').val();
            data[UNFA.type + '_rbt_bundle_text'] = JQ('#f_' + UNFA.type + '_rbt_bundle_text').val();
            data[UNFA.type + '_mwa'] = UNFA.get_mwa();
            data[UNFA.type + '_plus'] = JQ('#f_' + UNFA.type + '_plus').is(':checked') ? 1 : 0;
            data[UNFA.type + '_dnls'] = JQ('#f_' + UNFA.type + '_dnls').is(':checked') ? 1 : 0;
            data[UNFA.type + '_esg'] = JQ('#f_' + UNFA.type + '_esg').is(':checked') ? 1 : 0;
            data[UNFA.type + '_dynamik'] = JQ('#f_' + UNFA.type + '_dynamik').val() || 0;
            data[UNFA.type + '_integralfranchise'] = JQ('#f_' + UNFA.type + '_integralfranchise_1').is(':checked') ? 1 : 0;
            data['rbt_' + UNFA.type] = JQ('#f_rbt_' + UNFA.type).val();
            if (JQ('#f_rbt_' + UNFA.type + 'xf').length) {
                data['rbt_' + UNFA.type + 'xf'] = JQ('#f_rbt_' + UNFA.type + 'xf').is(':checked') ? 1 : 0;
            }
            JQ.getJSON(JSONURI,
                data,
                UNFA.addVProw);
        });

    },

    chk2: function (div) {
        BC.debug('UNFA.chk2() with:', div, 64);
        if (div == '#div_3' && UNFA.type == 'unfa2')
            UNFA.chkMinBtr(true);
    },

    chk_cnr: function () {
        BC.debug('UNFA.chk_cnr():', '', 64);
        if (!JQ('#f_' + UNFA.type + '_vp_cnr').length) return;
        var r = parseInt(JQ('#f_' + UNFA.type + '_vp_cnr').val());
        if (!r) return;
        if (!JQ('#f_' + UNFA.type + '_plus').is(':checked')) {
            JQ('#f_' + UNFA.type + '_plus').click();
            ALL.showInfo('Diese Deckungserweiterung ist nur bei Tarif Premium Plus möglich, daher wurde die Tarifvariante aktiviert.');
        }
        ALL.notifyHeight();
    },

    chk_mwa: function () {
        BC.debug('UNFA.chk_mwa():', '', 64);
        var _mwa = UNFA.get_mwa();
        if (!_mwa) return false;
        var _dnls = JQ("#f_" + UNFA.type + "_dnls").prop('checked');
        var _old = false;
        // t0: GebDat, age: Alter
        var t0, age;
        // t1 ist das gewünschte Beginndatum
        var t1 = moment(JQ('#f_' + UNFA.type + '_start').val(), 'DD.MM.YYYY');
        // t2 ist das früheste Beginndatum
        var t2 = moment(in2days, 'DD.MM.YYYY');
        JQ.each(UNFA.vps, function (k, v) {
            if (v['active'] != undefined && !v['active']) return true;
            if (v[UNFA.type + '_vp_gebdat'] != undefined)
                t0 = moment(v[UNFA.type + '_vp_gebdat'], 'DD.MM.YYYY');
            else if (v['vp_gebdat'] != undefined)
                t0 = moment(v['vp_gebdat'], 'DD.MM.YYYY');
            // age ist das Alter der VP zum Versicherungsbeginn
            age = t1.diff(t0, 'y', true);
            BC.debug('UNFA.chk_mwa(): AGE of ' + k + ' is ' + age, '', 64);
            if (age >= 66 || (age >= 64 && _dnls)) {
                _old = true;
            }
        });
        BC.debug('UNFA.chk_mwa(): 2old is:', _old, 64);
        if (!_old) {
            JQ('#f_' + UNFA.type + '_mwa_75').prop({'disabled': false});
            JQ('#f_' + UNFA.type + '_mwa_100').prop({'disabled': false});
        }
        return !_old;
    },

    chk_plus: function (e) {
        BC.debug('UNFA.chk_plus():', this, 64);
        var have_cnr = false;
        var _cnr = 0;
        var have_kop = false;
        var _kop = 0;
        e.stopPropagation();
        if (JQ(this).is(':checked')) {
            JQ('#div_' + UNFA.type + '_mwa').show();
            JQ.each(UNFA.vps, function (k, v) {
                _kop = parseInt(v[UNFA.type + '_vp_kop']);
                v[UNFA.type + '_vp_kop'] = '0';
                JQ('#tr_' + UNFA.type + '_vp_kop').addClass('hidden');
            });
            UNFA.chk_mwa();
            UNFA.chgZW();
            return;
        }
        JQ('#f_' + UNFA.type + '_mwa_50').click();
        JQ('#div_' + UNFA.type + '_mwa').hide();
        JQ('#tr_' + UNFA.type + '_vp_kop').removeClass('hidden');
        ALL.notifyHeight();
        // XXX: Reset of cnr for each VP!!!
        JQ.each(UNFA.vps, function (k, v) {
            _cnr = parseInt(v[UNFA.type + '_vp_cnr']);
            _kop = parseInt(v[UNFA.type + '_vp_kop']);
            if (_cnr && !have_cnr) have_cnr = true;
            if (_kop && !have_kop) have_kop = true;
            if (_cnr) v[UNFA.type + '_vp_cnr'] = '0';
            if (_kop) v[UNFA.type + '_vp_kop'] = '0';
        });
        if (have_cnr || have_kop) {
            BC.debug('UNFA.chk_plus(): Triggering recalc of all prems after deactivating plus-option', '', 64);
            ALL.showInfo('Ohne die Deckungserweiterung Premium Plus ist eine Mitversicherung von Sofortleistungen bei Krebserkrankungen nicht möglich, diese Tarifoption wurde sofern vorhanden bei den entsprechenden Personen deaktiviert.');
        }
        UNFA.chgZW();
    },

    chkDivReady: function (btn) {
        var r;
        BC.debug('UNFA.chkDivReady():', btn, 64);
        try {
            var b = BC.get_id(btn);
            var p = ALL.get_box_id(b);
            if (!p) return false;
            var d = BC.get_id(p);
        } catch (e) {
            BC.debug('UNFA.chkDivReady() rised an exception:', e, 16);
            Sentry.captureException(e);
            return false;
        }
        if (!d) return false;
        BC.debug('UNFA.chkDivReady() called for ' + b + ', vps_count =', UNFA.vps_count, 64);
        ALL.chkDivReady(d, true);
        switch (d) {
            case '#div_0':
                UNFA.screen = 1;
                return true;
            case '#div_1':
                return UNFA.vps_count;
            case '#div_2':
                // Haben wir zu allen VPs alle Angaben?
                // ? Beiträge berechnet? Und Datenschutzerklärunk bestätigt?
                return UNFA.chkVPScomplete() && JQ('#f_vn_ds_1').is(':checked');
            case '#div_3':
                if (parseInt(JQ('#f_' + UNFA.type + '_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_' + UNFA.type + '_rbt_bundle_text').val().length === 0) {
                    JQ('#vs-nr-hint-unfa2').show();
                    ALL.chgMobButton('#btn_fwd_3', false);
                    ALL.notifyHeight();
                } else {
                    JQ('#vs-nr-hint-unfa2').hide();
                    ALL.notifyHeight();
                    return (ALL.haveVN() && ALL.chkOpt(UNFA.type + '_plus') && UNFA.chkMinBtr(false) && ALL.date_chkStart(JQ('#f_' + UNFA.type + '_start')));
                }
            case '#div_4':
                UNFA.setChkFlds();
                JQ('span.vs').priceFormat({
                    centsLimit: 0,
                    prefix: '',
                    suffix: ' €',
                    thousandsSeparator: '.',
                });
                UNFA.o_possible = (PRIV.chkDA1() &&
                    ALL.chkOpt('da1_0') == '0' &&
                    ALL.chkOpt('da1_1') == '0' &&
                    ALL.chkOpt('da1_2') == '0' &&
                    ALL.chkOpt('da1_3'));
                BC.debug('UNFA.chkDivReady() in #div_4, o_possible:', UNFA.o_possible, 64);
                UNFA.set_vv();
                return UNFA.o_possible;
            case '#div_5':
                UNFA.setChkFlds();
                // XXX: Temporary disabled link-check!
                //PRIV.an_read = true;
                //PRIV.wd_read = true;
                r = PRIV.chkDA2();
                BC.debug('UNFA.chkDivReady(): #div_5 ready is', r, 64);
                if (r) return true;
                BC.debug('UNFA.chkDivReady(): #div_5 is NOT ready!', '', 64);
                break;
            case '#div_98':
                return true;
            case '#div_99':
                JQ('#div_' + UNFA.type + '_rslt').hide();
                ALL.triggerDataLayerEvent('Unfall', UNFA.type);
                return true;
            default:
                BC.debug('UNFA.chkDivReady() switch to default, BAD THING [tm]:', d, 16);
                break;
        }
        BC.debug('UNFA.chkDivReady(): ' + d + ' is NOT ready!', '', 64);
        return false;
    },

    chkDA4allvps: function () {
        // Prüfe, ob die Sammelfragen in Unfall-mobil korrekt beantwortet wurden
        var f;
        for (var i = 0; i <= 3; i++) {
            BC.debug('UNFA.chkDA4allvps() checking #div_da1_' + i, '', 512);
            try {
                f = JQ('#div_da1_' + i + ' input:checked').first();
                if (!f.length) return true;
                if (f.attr('data-notok')) {
                    ALL.showInfo(f.attr('data-notok'), 'Versicherung nicht möglich', true);
                    return true;
                }
            } catch (e) {
                BC.debug('UNFA.chkDA4allvps() failed:', e, 64);
                Sentry.captureException(e);
                return true;
            }
        }
        return false;
    },

    chkDA4vp: function () {
        // Prüfe bei jeder VP im DA-Form, ob zumindestens
        // die drei VP-JN-Fragen beantwortet wurden
        var b, i, d0, d1, d2;
        JQ.each(UNFA.vps, function (k, v) {
            b = v.branch;
            if (b != PRIV.branch) return true;
            i = v[b + '_vp_id'];
            BC.debug('UNFA.chkDA4vp() for VP ' + i + ', NO at F0 is checked:', JQ('#f_da1_' + i + '_0_0').is(':checked'), 64);
            d0 = v[b + '_vp_da1_0'] = JQ('#f_da1_' + i + '_0_0').is(':checked') ? 0 : 1;
            BC.debug('UNFA.chkDA4vp() for VP ' + i + ', NO at F1 is checked:', JQ('#f_da1_' + i + '_1_0').is(':checked'), 64);
            d1 = v[b + '_vp_da1_1'] = JQ('#f_da1_' + i + '_1_0').is(':checked') ? 0 : 1;
            BC.debug('UNFA.chkDA4vp() for VP ' + i + ', NO at F2 is checked:', JQ('#f_da1_' + i + '_2_0').is(':checked'), 64);
            d2 = v[b + '_vp_da1_2'] = JQ('#f_da1_' + i + '_2_0').is(':checked') ? 0 : 1;
            v[b + '_vp_da1_tfbeg'] = JQ('#f_da1_' + i + '_tfbeg').val();
            v[b + '_vp_da1_otheruv'] = JQ('#f_da1_' + i + '_otheruv').val();
            v[b + '_vp_da1_vorsch'] = JQ('#f_da1_' + i + '_vorsch').val();
            BC.debug('UNFA.chkDA4vp() =>', [d0, d1, d2], 64);
            if (d0 || d1 || d2) return false;
        });
        if (d0 || d1 || d2) return false;
        return true;
    },

    chkGG: function () {
        BC.debug('UNFA.chkGG()', '... starting ...', 64);
        UNFA.addVP();
    },

    chkMinBtr: function (hint) {
        BC.debug('UNFA.chkMinBtr()', '... starting ...', 64);
        if (hint == undefined) hint = false;
        var brt1 = 0.0;
        JQ.each(UNFA.vps, function (k, v) {
            brt1 += v.brt1;
        });
        if (brt1 < 20.0 && JQ('#f_da_za_2').is(':checked')) {
            // Zahlung per Rechnung mit unter 20 EUR nicht gewollt
            if (hint)
                ALL.showHint('Die Mindestprämie von 20,00 € bei Zahlung per Rechnung wird unterschritten, ein Abschluß ist so nicht möglich.');
            return false;
        } else if (brt1 < 10.0) {
            if (hint)
                ALL.showHint('Die Mindestprämie von 10,00 € wird unterschritten, ein Abschluß ist so nicht möglich.');
            return false;
        }
        return true;
    },

    chkVPcomplete: function (vp) {
        // Sind alle Angaben zu VP vp vorhanden. 0 < vp < 8
        // Angaben sind:
        // Anrede, Vor- und Nachname
        // Geburtsdatum
        // Beruf
        // VS INV
        // INV-Type
        // Explizite 0 bei UNR, TOD, KHT
        // Explizite Angabe zu exriding, exbiking, exskiing
        var _id = UNFA.type + '_vp_' + vp;
        var c = false;
        if (UNFA.vps[_id] == undefined) return;
        c = UNFA.vps[_id].complete = UNFA.vps[_id].active;
        if (!c) return;
        var flds = ['anrede', 'beruf', 'gebdat', 'nachname', 'vorname'];
        for (var f in flds) {
            if (UNFA.vps[_id].active) {
                UNFA.vps[_id]['vp_' + flds[f]] = JQ('#f_' + _id + '_' + flds[f]).val();
                JQ('#spanfini_' + _id + '_' + flds[f]).text(UNFA.vps[_id]['vp_' + flds[f]]);
            }
            if (c && !JQ('#f_' + _id + '_' + flds[f]).val())
                c = UNFA.vps[_id].complete = false;
        }
        flds = ['inv', 'invtype', 'unr', 'tod', 'kht', 'cnr'];
        for (f in flds) {
            if (UNFA.vps[_id].active) {
                JQ('#spanfini_' + _id + '_' + flds[f]).text(UNFA.vps[_id]['vp_' + flds[f]]);
                if (c && !JQ('#f_' + _id + '_' + flds[f]).val())
                    c = UNFA.vps[_id].complete = false;
                if (flds[f] == 'tod' && UNFA.vps[_id]['vp_' + flds[f]])
                    JQ('#spanfini_' + _id + '_todbeg').text(UNFA.vps[_id]['vp_todbeg']);
            }
        }
        UNFA.vps[_id]['vp_geschl'] = {'1': 'M', '2': 'W', '5': 'D'}[JQ('#f_' + _id + '_anrede').val()];
        JQ('#spanh4_' + _id + '_fullname').text(UNFA.vps[_id]['vp_fullname']);
        JQ('#div_4_da1_0_0_vp_' + vp).text(UNFA.vps[_id]['vp_fullname']);
        JQ('#div_4_da1_0_1_vp_' + vp).text(UNFA.vps[_id]['vp_fullname']);
        JQ('#div_4_da1_0_2_vp_' + vp).text(UNFA.vps[_id]['vp_fullname']);
        JQ('#spanfini_' + _id + '_fullname').text(({'M': 'Herr', 'W': 'Frau', 'D': ''}[UNFA.vps[_id]['vp_geschl']] )
            + UNFA.vps[_id]['vp_fullname']);
        flds = ['riding', 'biking', 'skiing'];
        for (f in flds) {
            if (!JQ('#f_' + _id + '_ex' + flds[f] + '_0').is(':checked') &&
                !JQ('#f_' + _id + '_ex' + flds[f] + '_1').is(':checked'))
                c = UNFA.vps[_id].complete = false;
            else if (JQ('#f_' + _id + '_ex' + flds[f] + '_0').is(':checked'))
                UNFA.vps[_id]['vp_ex' + flds[f]] = 0;
            else
                UNFA.vps[_id]['vp_ex' + flds[f]] = 1;
            JQ('#spanfini_' + _id + '_ex' + flds[f]).text(ALL.getYN('#f_' + _id + '_ex' + flds[f] + '_1'));
        }
        c = UNFA.vps[_id].complete && UNFA.vps[_id]['brt1'];
        BC.debug('UNFA.chkVPcomplete() VP ' + vp, c, 64);
        JQ('#img_foot_vp_' + vp).attr('src', (c
            ? '/images/psym-white100.svg'
            : '/images/psym-white50.svg'));
            ALL.notifyHeight();
    },

    chkVPScomplete: function () {
        var complete = true;
        for (var vp in UNFA.vps) {
            UNFA.chkVPcomplete(UNFA.vps[vp].num);
            if (UNFA.vps[vp].active) complete = complete && UNFA.vps[vp].complete;
        }
        return complete;
    },

    da_no: function () {
        // Falls eine VP eine der VP-spezifischen Fragen mit Ja beantwortet,
        // erscheint ein Hinweis der Nichtversicherbarkeit. Dafür haben die
        // entsprechenden Antwortfelder die Klasse "vp_nonins"
        BC.debug('UNFA.da_no()', '', 64);
        ALL.showHint('Aufgrund des Gesundheitszustandes kann die Waldenburger für diese Person keinen Versicherungsschutz anbieten. Bitte schließen Sie diesen Fragenkatalog mittles Klick auf die Schaltfläche "Abbrechen" und entfernen Sie die Person anschließend aus der Liste der zu versichernden Personen unterhalb des Reiters "Unfall".');
        JQ('#btn_da_ok').button('disable');
        ALL.notifyHeight();
    },

    get_mwa: function () {
        var _mwa = '';
        if (JQ('#f_' + UNFA.type + '_mwa').length)
            _mwa = JQ('#f_' + UNFA.type + '_mwa').val();
        else if (JQ('#div_' + UNFA.type + '_mwa input[name=' + UNFA.type + '_mwa]:checked').length)
            _mwa = JQ('#div_' + UNFA.type + '_mwa input[name=' + UNFA.type + '_mwa]:checked').val();
        BC.debug('UNFA.get_mwa():', _mwa, 64);
        return _mwa;
    },

    get_vps: function () {
        // Liefert die VPs für den jeweiligen Typ,
        // derzeit also unfa und unfa1 (Sonderkonzept)
        // In UNFA.vps sind alle VPs gespeichert, was bei
        // Parallelberechnung von beiden Produkten zu Kollisionen
        // führt
        var b;
        var _vps = {};
        JQ.each(UNFA.vps, function (k, v) {
            b = k.split('_')[0];
            if (!_vps[b]) {
                _vps[b] = {};
            }
            _vps[b][k] = v;
        });
        BC.debug('UNFA.get_vps():', _vps, 64);
        if (_vps[PRIV.branch]) return _vps[PRIV.branch];
        return _vps;
    },

    hide_tfbeg: function () {
        // Blende Todesfallbegünstigung aus bzw. ein abhängig
        // von Leitung im Todesfall je VP
        var b, d;
        JQ.each(UNFA.vps, function (k, v) {
            b = v.branch;
            if (b != PRIV.branch) return true;
            d = JQ('#div_da1_' + v[b + '_vp_id'] + '_tfbeg');
            if (v[b + '_vp_tod'] == '0') {
                d.hide();
            } else {
                d.show();
            }
        });
    },

    getOfferIdAndPostVersicherungspersonenToGetPdf: function () {
        JQ.getJSON(JSONURI, {
            action: 'offernr',
            branch: UNFA.type,
            sid: JQ('#f_sid').val(),
            csrf: JQ('body').data('csrf'),
        }, UNFA.postVersicherungspersonenAndGetOfferPdf)
    },

    postVersicherungspersonenAndGetOfferPdf: function (offerId) {
        var data = [];
        var versicherungsNehmerData = JQ('#fset_data_vn :input').serializeArray();
        var form = document.createElement('form');
        var $form = JQ(form).attr({
            action: '/tr/an',
            method: 'POST',
            target: 'pdfwin',
            style: 'display: none;',
        });

        data.push(UNFA.add_globals(data));

        var vps = UNFA.get_vps();

        Object.keys(vps).forEach(function (vp) {
            data.push({
                name: vp,
                value: JQ.param(vps[vp])
            })
        });

        data.push({
            name: 'da_onr',
            value: offerId.onr,
        }, {
            name: 'csrf',
            value: JQ('body').data('csrf'),
        }, {
            name: 'getunfalldoc',
            value: 'getunfalldoc',
        });

        data = data.concat(versicherungsNehmerData);

        data.forEach(function (field) {
            if (field) {
                $form.append('<input name="' + field.name + '" value="' + field.value + '" />')
            }
        });

        JQ('body').append($form);

        $form.submit();

        $form.remove();
        ALL.notifyHeight();
    },

    init: function () {
        PRIV.hideLogoutAndAdministration();
        if (isEsg && isEsg === 1) {
            JQ('#f_unfa_esg').prop('checked', true);
            JQ('#f_unfa1_esg').prop('checked', true);
            JQ('#f_unfa2_esg').prop('checked', true);
        }
        PRIV.createBundleRabattFieldsForBranch('unfa');
        PRIV.createBundleRabattFieldsForBranch('unfa1');
        PRIV.createBundleRabattFieldsForBranch('unfa2');
        if (ALL.mobile && ALL.branch.slice(0, 4) != UNFA.branch) return;
        UNFA.branch = JQ('#f_branch').val();
        BC.debug('UNFA.init(): branch: ' + UNFA.branch + ', type: ' + UNFA.type, '', 64);
        UNFA.type = UNFA.branch;
        //JQ('input.unfa_vs').mask('#.##0 €', {reverse: true});
        //JQ('input.unfa_vs').inputmask('[9]99.999 €', {numericInput: true});
        //JQ(':input').inputmask();
        //JQ('input.inv_vs').maskMoney();
        if (ALL.mobile) JQ('#f_' + UNFA.type + '_ende').val(in3year);
        if (ALL.mobile) {
            try {
                JQ('input.vs').priceFormat({
                    centsLimit: 0,
                    prefix: '',
                    thousandsSeparator: '.',
                });
            } catch (e) {
                BC.debug('UNFA.init() failed with priceFormat, check links', e, 64);
                Sentry.captureException(e);
            }
        }
        // Form für die Erfassung von VPs
        JQ('#div_unfa_add_vp').dialog({
            autoOpen: false,
            height: 780,
            modal: true,
            title: "Versicherte Person und Versicherungsumfang definieren",
            width: 530,
            // buttons will be set dynamic, see UNFA.chgBtns
        });
        JQ('#div_unfa1_add_vp').dialog({
            autoOpen: false,
            height: 780,
            modal: true,
            title: "Versicherte Person und Versicherungsumfang definieren",
            width: 530,
            // buttons will be set dynamic, see UNFA.chgBtns
        });
        JQ('#div_unfa2_add_vp').dialog({
            autoOpen: false,
            height: 780,
            modal: true,
            title: "Versicherte Person und Versicherungsumfang definieren",
            width: 530,
            // buttons will be set dynamic, see UNFA.chgBtns
        });

        JQ('#div_unfa2_mwa').hide();
        JQ('#btn_unfa2_mwa_50').click(function () {
            UNFA.setMWA(false)
        });

        JQ("input.vp_beruf_alt").autocomplete({
            select: function (e, ui) {
                BC.debug('autocomplete vp_beruf:', ui.item.value, 128);
                UNFA.vp_gg = ui.item;
            },
            autoFocus: true,
            minLength: 3,
            classes: {
                'ui-autocomplete': 'beruf-picker',
            },
            position: {my: "right top", at: "right bottom"},
            source: '/TR/json_brflist?sid=' + SESSION.getId(),
            //within: JQ('#div_unfa_add_vp')
        });

        //JQ('div.c1_4 > input.vp_beruf').click(UNFA.showBerufOverlay);
        JQ('div.c1_4 > input.vp_beruf').focus(UNFA.showBerufOverlay);

        JQ('input.cnr_vs').keyup(function () {
            var _vs = parseInt(JQ(this).unmask());
            if (_vs && !JQ('#f_' + UNFA.type + '_plus_1').is(':checked') && !isNaN(_vs)) {
                JQ('#f_' + UNFA.type + '_plus_1').click();
            } else if (isNaN(_vs)) {
                JQ(this).val(0);
            }
        });

        JQ('#f_' + UNFA.type + '_plus_0').click(function () {
            var have_cnr = false;
            JQ.each(UNFA.vps, function (k, v) {
                if (!v['active'] || !v['vp_cnr']) return true;
                have_cnr = true;
                return false;
            });
            if (have_cnr) {
                JQ('#overlay').removeClass('ovl-error').addClass('ovl-info').show();
                JQ('#div_premium_deselector').show().css({'display': 'grid'});
            }
            JQ('#f_' + UNFA.type + '_mwa').val(50);
            JQ('#btn_' + UNFA.type + '_mwa_50').removeClass('inactive').addClass('active');
            JQ('#btn_' + UNFA.type + '_mwa_75').removeClass('active').addClass('inactive');
            JQ('#btn_' + UNFA.type + '_mwa_100').removeClass('active').addClass('inactive');
            JQ('#div_' + UNFA.type + '_mwa').hide();
            JQ('#div_diseases_short').show();
            JQ('#div_da1_0').show();
            JQ('#div_diseases_long').hide();
            ALL.notifyHeight();
        });

        JQ('#f_' + UNFA.type + '_plus_1').click(function () {
            JQ('#div_' + UNFA.type + '_mwa').show();
            ALL.notifyHeight();
        });

        JQ('#div_premium_select').click(function () {
            JQ.each(UNFA.vps, function (k, v) {
                v['vp_cnr'] = 0;
                JQ('#f_' + k + '_cnr').val('0 €');
            });
            ALL.hideHint();
        });

        JQ('#div_pplus_keep').click(function () {
            JQ('#f_' + UNFA.type + '_plus_1').click();
            ALL.hideHint();
        });

        JQ('input.tod_vs').change(function () {
            var _vs = parseInt(JQ(this).unmask());
            var _f = BC.get_id(JQ(this)).replace(/_tod/, '_todbeg');
            var _div = _f.replace(/^#f_/, '#div_');
            var _div2 = _div.replace(/^#div/, '#divfini');
            if (_vs && !isNaN(_vs)) {
                JQ(_div).show();
                JQ(_div2).show();
                JQ(_f).focus();
            } else {
                JQ(_div).hide();
                JQ(_div2).hide();
            }
            ALL.notifyHeight();
        });

        JQ('input.gebdat').change(function () {
            BC.debug('Checking date', JQ(this).val(), 512);
            var rdat = /^(31|30|0[1-9]|[12]\d|[1-9])\.(0[1-9]|1[012]|[1-9])\.(\d{2,4})$/;
            var dmj = rdat.exec(JQ(this).val());
            var dat;
            if (!dmj || dmj[3].length == 3) {
                ALL.showHint('Die eingegebenen Werte stellen kein Datum dar!', true);
                JQ(this).focus();
                return;
            } else if (JQ(this).val().length == 10) {
                return;
            }
            dat = (dmj[1].length == 1 ? '0' : '') + dmj[1] + '.';
            dat += (dmj[2].length == 1 ? '0' : '') + dmj[2] + '.';
            dat += (dmj[3].length == 2 ? '19' : '') + dmj[3];
            JQ(this).val(dat);
        });

        JQ("#f_unfa_vp_beruf").autocomplete({
            select: function (e, ui) {
                BC.debug('autocomplete f_unfa_vp_beruf:', ui.item.value, 128);
                UNFA.vp_gg = ui.item;
            },
            autoFocus: true,
            minLength: 3,
            classes: {
                'ui-autocomplete': 'beruf-picker',
            },
            position: {my: "right top", at: "right bottom"},
            source: '/TR/json_brflist?sid=' + SESSION.getId(),
            within: JQ('#div_unfa_add_vp')
        });

        JQ("#f_unfa1_vp_beruf").autocomplete({
            select: function (e, ui) {
                BC.debug('autocomplete f_unfa1_vp_beruf:', ui.item.value, 128);
                UNFA.vp_gg = ui.item;
            },
            autoFocus: true,
            minLength: 3,
            classes: {
                'ui-autocomplete': 'beruf-picker',
            },
            position: {my: "right top", at: "right bottom"},
            source: '/TR/json_brflist?sid=' + SESSION.getId(),
            within: JQ('#div_unfa1_add_vp')
        });

        JQ("#f_unfa2_vp_beruf").autocomplete({
            select: function (e, ui) {
                BC.debug('autocomplete f_unfa2_vp_beruf:', ui.item.value, 128);
                UNFA.vp_gg = ui.item;
            },
            autoFocus: true,
            minLength: 3,
            classes: {
                'ui-autocomplete': 'beruf-picker',
            },
            position: {my: "right top", at: "right bottom"},
            source: '/TR/json_brflist?sid=' + SESSION.getId(),
            within: JQ('#div_unfa2_add_vp')
        });

        JQ('#btn_unfa_create_vp').button({text: true}).click(UNFA.newVPwin0);
        JQ('#btn_unfa1_create_vp').button({text: true}).click(UNFA.newVPwin1);
        JQ('#btn_unfa2_create_vp').button({text: true}).click(UNFA.newVPwin2);

        JQ('#div_unfa_add_vp').change(function () {
            UNFA.addVP()
        });
        JQ('#div_unfa1_add_vp').change(function () {
            UNFA.addVP()
        });
        JQ('#div_unfa2_add_vp').change(function () {
            UNFA.addVP()
        });

        JQ('#div_unfa2_vps_bxs input').change(UNFA.set_vps_num);
        JQ('#div_unfa2_vps_btn button').click(UNFA.set_vps_num);
        JQ('input.unfa_chk_risk').click(function () {
            if (JQ(this).is(':checked')) UNFA.showInfo('Person nicht versicherbar', 'PROBLEM');
        });
        JQ('input.unfa2_chk_risk').click(function () {
            if (JQ(this).is(':checked')) UNFA.showInfo('Person nicht versicherbar', 'PROBLEM');
        });

        JQ('#tbody_unfa_vps').click(UNFA.chgVP);
        JQ('#tbody_unfa1_vps').click(UNFA.chgVP);
        JQ('#tbody_unfa2_vps').click(UNFA.chgVP);


        if (ALL.mobile) {
            JQ('#f_unfa2_rbt_bundle').change(UNFA.recalcMobile);
            JQ('#f_unfa_rbt_bundle_text, #f_unfa1_rbt_bundle_text, #f_unfa2_rbt_bundle_text').change(UNFA.recalcMobile);
        }

        JQ('#f_unfa2_vp_cnr').change(UNFA.chk_cnr);
        JQ('#f_unfa2_plus').change(UNFA.chk_plus);

        JQ('#f_vp_beruf_in').keyup(UNFA.loadBerufe);

        JQ('div.unfa2_invtypes > button.btn_unfa').click(function () {
            var _id = BC.get_id(this).split('_');
            var _itype = _id[_id.length - 1];
            _id = _id[_id.length - 2];
            JQ('#div_' + UNFA.type + '_vp_' + _id + '_invtypes > button.btn_unfa').removeClass('active').addClass('inactive');
            JQ(this).removeClass('inactive').addClass('active');
            JQ('#f_' + UNFA.type + '_vp_' + _id + '_invtype').val(_itype);
            UNFA.calc_vp(_id);
            ALL.notifyHeight();
        });

        JQ('#div_unfa2_mwa button.btn_unfa').click(function () {
            var _id = BC.get_id(this).split('_');
            var _mwa = _id[_id.length - 1];
            UNFA.divtop = ALL.get_w_sizes().win_t;
            if (_mwa == '75' || _mwa == '100') {
                JQ('#f_' + UNFA.type + '_mwa').val(_mwa);
                JQ('#div_mwa_disease').show().css({'display': 'grid'});
                JQ('#div_3').css({'position': 'fixed', 'top': -UNFA.divtop});
                ALL.notifyHeight();
                return;
            }
            JQ('#div_' + UNFA.type + '_mwa button.btn_unfa').removeClass('active').addClass('inactive');
            JQ('#btn_' + UNFA.type + '_mwa_50').removeClass('inactive').addClass('active');
            JQ('#f_' + UNFA.type + '_mwa').val(50);
            UNFA.recalcMobile();
            ALL.notifyHeight();
        });

        JQ('#div_mwa_disease_no').click(function () {
            UNFA.setMWA(true);
            JQ('#div_unfa2_integralfranchise_row').hide();
            ALL.notifyHeight();
        });

        JQ('#div_mwa_disease_yes').click(function () {
            UNFA.setMWA(false);
            ALL.showHint('Die Erhöhung des Mitwirkungsanteils ist nicht möglich.');
            JQ('#div_unfa2_integralfranchise_row').show();
            ALL.notifyHeight();
        });

        JQ('input.vp_name').keyup(function (e) {
            var fld, vp;
            var _id = BC.get_id(this).split('_');
            var _itype = _id[_id.length - 1];
            e.stopPropagation();
            vp = _id[_id.length - 2];
            _id = UNFA.type + '_vp_' + vp;
            UNFA.vps[_id]['vp_vorname'] = JQ('#f_' + _id + '_vorname').val();
            UNFA.vps[_id]['vp_nachname'] = JQ('#f_' + _id + '_nachname').val();
            UNFA.vps[_id]['vp_fullname'] = ((!UNFA.vps[_id]['vp_vorname'] && !UNFA.vps[_id]['vp_nachname'])
                ? 'Person ' + vp
                : UNFA.vps[_id]['vp_vorname'] + ' ' + UNFA.vps[_id]['vp_nachname']);
            fld = '#span_' + _id + '_fullname';
            JQ(fld).text(UNFA.vps[_id]['vp_fullname']);
        });

        if (ALL.mobile) {
            for (var i = 1; i < 8; i++) {
                JQ('#div_' + UNFA.type + '_vp_' + i + '_vers').change(UNFA.calc_vp);
            }
            JQ('#div_' + UNFA.type + '_dnls').change(UNFA.recalcMobile);
            JQ('#div_' + UNFA.type + '_esg').change(UNFA.recalcMobile);
            JQ('#div_' + UNFA.type + '_plus').change(UNFA.recalcMobile);
            JQ('#div_' + UNFA.type + '_zw').change(UNFA.recalcMobile);
            JQ('#div_' + UNFA.type + '_start').change(UNFA.recalcMobile);
            JQ('#f_da_za_2').click(function () {
                UNFA.chkMinBtr(true)
            });
        }

        //JQ('#f_unfa2_dnls').click(UNFA.canCalc);

        JQ('#a_da_wording').click(function () {
            PRIV.wd_read = true;
            ALL.chkDivReady('a_da_wording', true);
            ALL.chgMobButtons(UNFA.type);
        });

        JQ('#f_unfa2_integralfranchise_1').change(function () {
            if (JQ(this).val())
            {
                // /TR/mprv
                JQ('#f_unfa2_mwa_50').click();

                // /p/unfall
                JQ('#btn_unfa2_mwa_50').click();
            }
        });

        JQ('#f_unfa2_integralfranchise_0').click(function () {
            UNFA.recalcMobile();
        });

        var setIntegralFranchiseToFalse = function () {
            JQ('#f_unfa2_integralfranchise_0').click();
        };

        // /TR/mprv
        JQ('#f_unfa2_mwa_75').click(setIntegralFranchiseToFalse);
        JQ('#f_unfa2_mwa_100').click(setIntegralFranchiseToFalse);

        // /p/unfall
        JQ('#btn_unfa2_mwa_50').click(function () {
            JQ('#div_unfa2_integralfranchise_row').show();
        });
        JQ('#btn_unfa2_mwa_75').click(setIntegralFranchiseToFalse);
        JQ('#btn_unfa2_mwa_100').click(setIntegralFranchiseToFalse);
        ALL.notifyHeight();
    },

    loadBerufe: function () {
        var _job = JQ(this).val();
        if (_job.length < 3) return;
        JQ.getJSON(JSONURI,
            {
                action: 'brflist',
                sid: JQ('#f_sid').val(),
                term: _job
            },
            UNFA.showBerufe);
    },

    make_post_data: function () {
        // Erstelle POST-Daten
        var t = UNFA.type;
        var pd = {
            'branch': t,
            'vps': {},
            'cqrs': JQ('body').data('csrf')
        };
        var vp_prefix = RegExp('^' + t + '_vp_');
        JQ.each(UNFA.vps, function (k, v) {
            if (v['complete']) pd.vps[k] = v;
        });
        JQ.each(ALL.deserial(JQ('#frm_' + t).serializeArray()), function (k, v) {
            if (k.match(vp_prefix)) return true;
            pd[k] = v;
        });
        return pd;
    },

    newVPwin: function () {
        // Oeffne PopUp für VP-Eingabe in Unfall
        BC.debug('UNFA.newVPwin() for UNFA.type ', UNFA.type, 64);
        JQ('#f_' + UNFA.type + '_action').val('getpremvp');
        JQ('#f_' + UNFA.type + '_todo').val('add');
        //JQ('#f_' + UNFA.type + '_vp_id').val(++UNFA.vp_id);
        UNFA.chgBtns(false);
        JQ('#div_' + UNFA.type + '_add_vp').dialog('open');
        JQ('body').css('min-height', JQ('#div_' + UNFA.type + '_add_vp').height() + 100);
        JQ('#' + UNFA.type + '_reset_add_vp').click();
        JQ('#f_' + UNFA.type + '_vp_inv').val(100);
        UNFA.age_hint = false;
        ALL.notifyHeight();
    },

    newVPwin0: function () {
        // Oeffne PopUp für VP-Eingabe in Unfall
        UNFA.type = 'unfa';
        UNFA.newVPwin();
    },

    newVPwin1: function (e) {
        // Oeffne PopUp für VP-Eingabe in Unfall
        UNFA.type = 'unfa1';
        UNFA.newVPwin();
    },

    newVPwin2: function (e) {
        // Oeffne PopUp für VP-Eingabe in Unfall
        UNFA.type = 'unfa2';
        UNFA.newVPwin();
    },

    optimizeBrt1: function (e) {
        // Versuche immer mit der ZW zu kalkulieren, die den
        // geringsten Beitrag darstellt. Nur sinnvoll in stages vor
        // expliziter Auswahl der ZW,DNLS etc. (bei Unfall also vor screen 3)
    },

    recalcMobile: function (e) {
        // Erzwinge Neuberechnung aller VPs
        BC.debug('UNFA.recalcMobile() called, event:', e, 64);
        if (e) e.stopPropagation();
        UNFA.setBparts();
        JQ.each(UNFA.vps, function (k, v) {
            if (v.active) {
                UNFA.calc_vp(v.num);
            }
        });
    },

    recalcPrSum: function () {
        UNFA.setBparts();

        var prsum = 0.0;
        var _btr = {
            net2: 0.0,
            vst2: 0.0,
            brt2: 0.0,
            brt1: 0.0
        };
        JQ('#tbody_' + UNFA.type + '_vps .brt3').each(function (i) {
            prsum += ALL.cur2flt(JQ(this).text());
            BC.debug('UNFA.recalcPrSum():', [prsum, UNFA.btr, JQ(this).text()], 64);
        });
        JQ.each(UNFA.btr, function (i, o) {
            BC.debug('UNFA.recalcPrSum(i, o):', [i, o], 64);
            if (!o || i.split('_')[0] != UNFA.type) return true;
            JQ.each(_btr, function (k, v) {
                BC.debug('UNFA.recalcPrSum(_btr: k, v):', [k, v], 256);
                if (k in o.sums) _btr[k] += o.sums[k];
            });
            BC.debug('UNFA.recalcPrSum(_btr):', _btr, 64);
        });
        JQ.each(_btr, function (k, v) {
            BC.debug('UNFA.recalcPrSum(_btr: k, v):', [k, v], 512);
            if (JQ('#f_' + UNFA.type + '_' + k).length) {
                JQ('#f_' + UNFA.type + '_' + k).text(ALL.flt2cur(v));
                if (k == 'brt1') JQ('#f_all_' + UNFA.type).text(ALL.flt2cur(v));
            }
        });
        ALL.chkContactData();
        var isMehrVertragNachlassValid = parseInt(JQ('#f_' + UNFA.type + '_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_' + UNFA.type + '_rbt_bundle_text').val().length === 0;
        if (_btr['brt1']) {
            // XXX - Change next line when UNFA-DA is possible
            JQ('#spn_' + UNFA.type + '_da_btn').hide();
            ALL.chgProduct(UNFA.type, _btr['brt1']);
            JQ('#b_' + UNFA.type + '_go2datavn').button("option", "disabled", isMehrVertragNachlassValid);
            if (isMehrVertragNachlassValid) {
                JQ('#vs-nr-hint-' + UNFA.type).show();
            } else {
                JQ('#vs-nr-hint-' + UNFA.type).hide();
            }
        } else {
            JQ('#b_' + UNFA.type + '_go2datavn').button("option", "disabled", isMehrVertragNachlassValid);
            if (isMehrVertragNachlassValid) {
                JQ('#vs-nr-hint-' + UNFA.type).show();
            } else {
                JQ('#vs-nr-hint-' + UNFA.type).hide();
            }
            ALL.chgProduct(UNFA.type, null);
        }
        ALL.notifyHeight();
    },

    selectBeruf: function () {
        var beruf = JQ(this).text();
        if (beruf != undefined && beruf.trim()) {
            JQ('#f_vp_beruf_in').val(beruf.trim());
            JQ('#f_' + UNFA.type + '_vp_' + UNFA.current_vp + '_beruf').val(beruf.trim());
        }
        JQ(this).parent().children().css({'background-color': '', 'color': ''});
        JQ(this).css({'background-color': '#959595', 'color': '#FFF'});
        ALL.hideHint();
        JQ('#div_2').css({'position': '', top: ''});
        window.scrollTo(0, UNFA.divtop);
        ALL.notifyHeight();
    },

    setBparts: function () {
        var isPlus = JQ('#f_' + UNFA.type + '_plus_1').is(':checked') || JQ('#f_' + UNFA.type + '_plus').is(':checked');
        PRIV.bparts[UNFA.type] = isPlus ? ['plus'] : ['prem'];

        JQ('.display-on-esg_' + UNFA.type).hide();
        if (ALL.mobile) {
            if (isPlus) {
                JQ('#a_da_wording').attr('href', '/TR/dl4/B-Unfall-Plus-20211015.pdf')
            } else {
                JQ('#a_da_wording').attr('href', '/TR/dl4/B-Unfall-20211015.pdf')
            }
        }

        if (JQ("#f_" + UNFA.type + "_esg").is(':checked') && PRIV.bparts[UNFA.type].indexOf('esg') < 0) {
            if (UNFA.type === 'unfa2') {
                // "premesg" or "plusesg"
                PRIV.bparts[UNFA.type] = [PRIV.bparts[UNFA.type][0] + 'esg'];
            } else {
                PRIV.bparts[UNFA.type].push('esg');
            }
            JQ('.display-on-esg_' + UNFA.type).show();
            if (ALL.mobile) {
                if (isPlus) {
                    JQ('#a_da_wording').attr('href', '/TR/dl4/B-Unfall-Plus-ESG-20211015.pdf')
                } else {
                    JQ('#a_da_wording').attr('href', '/TR/dl4/B-Unfall-ESG-20211015.pdf')
                }
            }
        }
        ALL.notifyHeight();
    },

    setChkFlds: function () {
        // Belege Felder in "Angaben überprüfen"
        // Aufruf teilweise in ALL.set_HNR
        if (ALL.mobile) {
            ALL.setChkFlds(UNFA.type);
            ALL.chkDate(JQ('#f_' + UNFA.type + '_ende'));
        }
        JQ('#m098_tarif').text(ALL.chkChkBox('f_' + UNFA.type + '_plus_1') ? 'Premium Plus' : 'Premium');
        JQ('#m098_dnls').text(ALL.getYN('f_' + UNFA.type + '_dnls'));
        JQ('#m098_mwa').text(JQ('#f_' + UNFA.type + '_mwa').val() + '%');
        JQ('#m098_integralfranchise').text(JQ('#f_' + UNFA.type + '_integralfranchise_1').is(':checked') ? 'Ja' : 'Nein');
        JQ('#m098_dynamik').text(JQ('#f_' + UNFA.type + '_dynamik').val() === '0' ? 'Ohne Dynamik' : JQ('#f_' + UNFA.type + '_dynamik').val() + '%');
    },

    setFlds: function (data) {
        if (isEsg === 1) {
            JQ('#f_' + UNFA.type + '_esg').prop('checked', true)
        }
        BC.debug('UNFA.setFlds(): data: ', data, 64);
        ALL.chkError(data);
        if (ALL.err) {
            UNFA.dry = true;
            return;
        }
        JQ.each(data, function (key, val) {
            if (val.str === undefined) {
                BC.debug('UNFA.setFlds(): Setting #f_' + UNFA.type + '_vp_' + key + ' to ' + val, '', 64);
                JQ('#f_' + UNFA.type + '_vp_' + key).text(val);
            } else {
                BC.debug('UNFA.setFlds(): Setting #f_' + UNFA.type + '_vp_' + key + ' to ' + val.str, '', 64);
                JQ('#f_' + UNFA.type + '_vp_' + key).text(val.str);
            }
        });
    },

    setMWA: function (yn) {
        var _mwa = yn ? parseInt(UNFA.get_mwa()) : 50;
        BC.debug('UNFA.setMWA(): => ', _mwa, 64);
        JQ('#div_' + UNFA.type + '_mwa button.btn_unfa').removeClass('active').addClass('inactive');
        JQ('#btn_' + UNFA.type + '_mwa_' + _mwa).removeClass('inactive').addClass('active');
        JQ('#f_' + UNFA.type + '_mwa').val(_mwa);
        UNFA.recalcMobile();
        ALL.hideHint();
        if (yn && _mwa > 50) {
            JQ('#div_da1_0').hide();
            JQ('#f_da1_0_0').attr('checked', true);
            JQ('#div_sum_mwa').show();
            JQ('#div_diseases_short').hide();
            JQ('#div_diseases_long').show();
        } else {
            JQ('#div_da1_0').show();
            JQ('#f_da1_0_0').removeAttr('checked');
            JQ('#div_sum_mwa').hide();
            JQ('#div_diseases_long').hide();
            JQ('#div_diseases_short').show();
        }
        JQ('#div_3').css({'position': '', 'top': ''});
        window.scroll(0, 0);
        ALL.notifyHeight();
    },

    set_vp: function (counter, active) {
        // Erzeuge bzw. aktiviere / deaktiviere VP in UNFA.vps
        // Befülle Array mit Werten aus Form
        var _id = UNFA.type + '_vp_' + counter;
        if (!UNFA.vps[_id])
            UNFA.vps[_id] = {
                'complete': false,
                'brt1': 0.0,
                'brt2': 0.0,
                'num': counter,
                'vp_id': counter
            };
        UNFA.vps[_id]['active'] = active;
        UNFA.vps[_id]['shownr'] = counter;
        if (!active || active) return;
        UNFA.vps[_id]['vp_beruf'] = JQ('#f_' + _id + '_beruf').val();
        UNFA.vps[_id]['vp_gebdat'] = JQ('#f_' + _id + '_beruf').val();
        UNFA.vps[_id]['vp_geschl'] = {'1': 'M', '2': 'W', '5': 'D'}[JQ('#f_' + _id + '_anrede').val()];
        UNFA.vps[_id]['vp_inv'] = parseInt(JQ('#f_' + _id + '_inv').val());
        UNFA.vps[_id]['vp_inv_type'] = parseInt(JQ('#f_' + _id + '_invtype').val());
        UNFA.vps[_id]['vp_kht'] = parseInt(JQ('#f_' + _id + '_kht').val());
        UNFA.vps[_id]['vp_tod'] = parseInt(JQ('#f_' + _id + '_tod').val());
        UNFA.vps[_id]['vp_unr'] = parseInt(JQ('#f_' + _id + '_unr').val());
    },

    set_vp_btr: function (data) {
        // Callback aus calc_vp
        BC.debug('UNFA.set_vp_btr()', data, 64);
        if (data.ERROR) {
            ALL.chkError(data);
            ALL.chgMobButton('#btn_fwd_2', false)
            return;
        }
        var _id = UNFA.type + '_vp_' + data.id;
        UNFA.vps[_id]['ggroup'] = data.ggroup;
        UNFA.vps[_id]['brt1'] = data.brt1.val;
        UNFA.vps[_id]['brt2'] = data.brt2.val;
        UNFA.vps[_id]['net1'] = data.net1.val;
        UNFA.vps[_id]['net2'] = data.net2.val;
        BC.debug('UNFA.set_vp_btr()', UNFA.vps[_id], 64);
        UNFA.set_vps_brt1();
        UNFA.set_vp(data.id, true);
    },

    set_vps: function (vps) {
        var b;
        BC.debug('UNFA.set_vps(): vps =>', vps, 64);
        JQ.each(vps, function (uk, uv) {
            if (uk.slice(0, 3) == 'rbt') return true;
            BC.debug('UNFA.set_vps(): for ' + uk, uv, 64);
            b = ALL.branch = PRIV.branch = uv.branch;
            if (uv.branch == 'unfa1') {
                UNFA.newVPwin1();
            } else if (uv.branch == 'unfa2') {
                UNFA.newVPwin2();
            } else {
                UNFA.newVPwin();
            }
            JQ.each(uv, function (k, v) {
                if (k.slice(-5) == '_ende' || k.slice(-6) == '_start') ALL.fillField(k, v);
            });
            ALL.chkDate(uv);
            BC.debug('UNFA.set_vps(): Begin and End set', '', 64);
            JQ.each(uv, function (k, v) {
                if (k.slice(-5) == '_ende' || k.slice(-6) == '_start') return true;
                ALL.fillField(k, v);
            });
            UNFA.addVPreal(uv);
        });
    },

    set_vps_brt1: function () {
        // Setze BRT1
        var brt1 = 0.0;
        BC.debug('UNFA.set_vps_brt1():', '', 64);
        // Gesamtsummen ermitteln:
        JQ.each(UNFA.vps, function (k, v) {
            if (v.active) {
                brt1 = brt1 + v.brt1;
            }
        });
        BC.debug('UNFA.set_vps_brt1(): BRT1 =', brt1, 64);
        JQ('#f_' + UNFA.type + '_brt1').text(ALL.flt2cur(brt1));
        ALL.chgProduct(UNFA.type, brt1);
    },

    set_vps_num: function () {
        var i, j, n, d1, d2, h4, i1;
        if (JQ(this).hasClass('btn_add_vps')) {
            j = parseInt(JQ(this).prop('id').slice(-1));
        } else {
            j = 0;
        }
        BC.debug('UNFA.set_vps_num(): j => ', j, 64);
        UNFA.vps_count = 0;
        if (JQ('#f_' + UNFA.type + '_vp_3').is(':checked')) {
            JQ('#div_' + UNFA.type + '_vps_btn').show();
            if (!j) {
                j = JQ('#div_' + UNFA.type + '_vps_btn .active').prop('id');
                if (j && j != undefined) j = parseInt(j.slice(-1));
            }
        } else {
            JQ('#div_' + UNFA.type + '_vps_btn').hide();
        }
        for (i = 1; i < 3; i++) {
            if (JQ('#f_' + UNFA.type + '_vp_' + i).is(':checked')) {
                UNFA.vps_count++;
                UNFA.set_vp(i, true);
                //JQ('#div_' + UNFA.type + '_vp_' + i + '_vers').removeClass('hidden');
                //JQ('#div_' + UNFA.type + '_vp_' + i + '_rslt').removeClass('hidden');
                BC.debug('UNFA.set_vps_num(): UNFA.vps_count => ', UNFA.vps_count, 64);
            } else {
                UNFA.set_vp(i, false);
                //JQ('#div_' + UNFA.type + '_vp_' + i + '_vers').addClass('hidden');
                //JQ('#div_' + UNFA.type + '_vp_' + i + '_rslt').addClass('hidden');
            }
        }
        for (i = 3; i < 8; i++) {
            n = '#btn_' + UNFA.type + '_add_vps_' + i;
            if (i <= j) {
                UNFA.vps_count++;
                UNFA.set_vp(i, true);
                if (i == j) JQ(n).removeClass('inactive').addClass('active');
                else JQ(n).removeClass('active').addClass('inactive');
            } else if (j) {
                JQ(n).removeClass('active').addClass('inactive');
                UNFA.set_vp(i, false);
            } else {
                UNFA.set_vp(i, false);
            }
            ALL.notifyHeight();
        }
        BC.debug('UNFA.set_vps_num()  persons to insure:', UNFA.vps_count, 64);
        i = 0;
        JQ.each(UNFA.vps, function (k, v) {
            d1 = '#div_' + k + '_vers';
            d2 = '#div_' + k + '_rslt';
            h4 = '#span_' + k + '_fullname';
            i1 = '#img_foot_vp_' + v.num;
            if (v.active) {
                JQ(d1).removeClass('hidden');
                JQ(d2).removeClass('hidden');
                JQ(i1).removeClass('hidden');
                i++;
                if (v.vp_fullname)
                    JQ(h4).text(v.vp_fullname);
                else
                    JQ(h4).text('Person ' + i);
            } else {
                JQ(d1).addClass('hidden');
                JQ(d2).addClass('hidden');
                JQ(i1).addClass('hidden');
            }
        });
        if (JQ(this).hasClass('btn_add_vps')) UNFA.change();
        ALL.chgProduct(UNFA.type, UNFA.vps_count);
        //if (UNFA.vps_count) {
        //    JQ('#div_' + UNFA.type + '_rslt').show();
        //} else {
        //    JQ('#div_' + UNFA.type + '_rslt').hide();
        //}
        ALL.notifyHeight();
    },

    set_vv: function () {
        BC.debug('UNFA.set_vv(): called', '', 64);
        var html;
        if (JQ('#f_da_vv1_1').is(':checked') && JQ('#f_da_vv2_1').is(':checked')) {
            html = ('Es bestand eine Vorversicherung:<br/>' +
                'Gesellschaft: ' + JQ('#f_da_vv3').val() + '<br/>' +
                'Versicherungsnummer: ' + JQ('#f_da_vv4').val() + '<br/>' +
                'Ablaufdatum: ' + JQ('#f_da_vv5').val());
        } else if (JQ('#f_da_vv1_0').is(':checked')) {
            html = 'Es bestand keine Vorversicherung.';
        } else {
            html = '<b>VERSICHERUNGSSCHUTZ NICHT MÖGLICH!</b>';
            PRIV.canDA = false;
        }
        JQ('#span_last_da_vv1').html(html);
        if (JQ('#f_da_rem').val()) JQ('#span_last_da_rem').text(JQ('#f_da_rem').val());
        else JQ('#span_last_da_rem').text('------');
        ALL.notifyHeight();
    },

    showBerufe: function (data) {
        if (!data) return;
        var ul = JQ('#ul_berufe');
        var li;
        ul.empty();
        JQ.each(data, function (key, val) {
            li = JQ('<li class="beruf">' + val + '</li>');
            ul.append(li);
            li.click(UNFA.selectBeruf);
            ALL.notifyHeight();
        });
    },

    showBerufOverlay: function () {
        var pos = JQ(this).offset();
        var wid = JQ(this).width();
        UNFA.divtop = ALL.get_w_sizes().win_t;
        var vp;
        try {
            vp = parseInt(JQ(this).prop('id').match(/_(\d)_/)[1]);
        } catch (e) {
            Sentry.captureException(e);
            return;
        }
        if (vp != UNFA.current_vp) {
            UNFA.current_vp = vp;
            JQ('#f_vp_beruf_in').val('');
            JQ('#ul_berufe').empty();
        }
        pos.top += 35 - window.scrollY;
        pos.left /= 2;
        JQ('#div_2').css({'position': 'fixed', 'top': -UNFA.divtop});
        JQ('#overlay').show();
        JQ('#div_berufe').show().css(pos).width(wid);
        //JQ('#div_berufe').show().css({'top':UNFA.divtop, 'left': pos.left}).width(wid);
        JQ('#div_berufe svg.cb').click(UNFA.selectBeruf);
        var v = JQ('#f_vp_beruf_in').val();
        if (v) v = v.trim();
        JQ('#f_vp_beruf_in').focus().val('');
        JQ('#f_vp_beruf_in').val(v);
        ALL.notifyHeight();
    },

    showInfo: function (t, h) {
        // function called by (i)-Buttons resp. div in which button is placed
        // div has i.e. id "ibtn_hara2_ded"
        // so hara2 is the branch => HARA2
        // and ded is the entry which must exist in namespace HARA2.info
        // HARA.info.ded.head is the text for #head_info
        // HARA.info.ded.html is the html for #text_info
        var w = ALL.get_w_sizes();
        var top = w.win_t + w.win_h / 2;
        var info;
        if (h === undefined) h = '';
        BC.debug('UNFA.showInfo for mobile would show: ', [t, h, this, ALL.classof(t)], 64);
        if (JQ(this).attr('data-infoHtml')) {
            JQ('#head_info').html(JQ(this).attr('data-infoHead'));
            JQ('#text_info').html(JQ(this).attr('data-infoHtml'));
        } else if (!t || ALL.classof(t) == 'Object') {
            var b = BC.get_id(this).split('_');
            BC.debug('UNFA.showInfo for mobile would show:', [t, b, this], 256);
            try {
                if (this.dataset.infohead) {
                    info = {
                        'head': this.dataset.infohead,
                        'html': this.dataset.infohtml
                    };
                } else {
                    info = PRIV[b[1]]['info'][b[2]];
                }
                if (!info) return;
            } catch (e) {
                BC.debug('UNFA.showInfo() failed!', e, 16);
                return;
            }
            JQ('#head_info').text(info['head']);
            JQ('#text_info').html(info['html']);
        } else {
            JQ('#head_info').text(h);
            JQ('#text_info').html(t);
        }
        if (h.toUpperCase() == 'FEHLER') {
            JQ('#prob_head_info').css({'color': '#FFFFFF'})
            JQ('#overlay').removeClass('ovl-info').addClass('ovl-error').show();
            JQ('#div_vp_prob').removeClass('info').addClass('error');
            JQ('#div_accept_delete').addClass('button_error');
            JQ('#svg_prob_close_btn').css({'fill': '#FFFFFF'});
            JQ('#prb_cb_99').css({'stroke': '#F7A707', 'fill': '#F7A707'});
        } else {
            JQ('#prob_head_info').css({'color': '#000'})
            JQ('#overlay').removeClass('ovl-error').addClass('ovl-info').show();
            JQ('#div_vp_prob').removeClass('error').addClass('info');
            JQ('#div_accept_delete').removeClass('button_error');
            JQ('#svg_prob_close_btn').css({'fill': '#CC0000'});
            JQ('#prb_cb_99').css({'stroke': '#FFFFFF', 'fill': '#FFFFFF'});
        }
        top = top - JQ('#div_info').height() / 2;
        JQ('#div_info').show().css({'display': 'grid'});
        ALL.notifyHeight();
    },

    vp_with_chkbox: function (d, vp) {
        // Liefere JQ-Element, das als checkbox-Reihe eingefügt werden kann
        //
        // Checkbox-"Reihen" sehen wie folgt aus:
        //    <div class="c1_4 r1">
        //      <div class="d4rb_l">
        //        <input type="checkbox" id="f_unfa_vp_1" name="unfa_vp_1" value="1" />
        //        <label class="checkbox" for="f_unfa_vp_1"><span class="checkbox"></span></label>
        //      </div>
        //      <div class="d4lbl_r">
        //        <label for="f_unfa_vp_1"><b>LABEL</b></label>
        //      </div>
        //    </div>
        var f = 'f_vp_chk_r_' + d + '_' + vp.num;
        var t0 = JQ('<div></div>').addClass('c1_4');
        var t1 = JQ('<div></div>').addClass('d4rb_l');
        t0.append(t1);
        var ti = JQ('<input type="checkbox" />').addClass('unfa_chk_risk').prop('id', f).val(1);
        t1.append(ti);
        var t2 = JQ('<label></label>').addClass('checkbox').prop('for', f);
        t1.append(t2);
        t2.append(JQ('<span></span>').addClass('checkbox'));
        t0.append(JQ('<div>' + vp.vp_fullname + '</div>').addClass('d4lbl_r'));
        //t[t.length-1].append(JQ('<span></span>').addClass('checkbox'));
        //var t = '<div class="d4rb_l">' +
        //        '<input class="unfa_chk_risk" type="checkbox" id="f_vp_chk_r_' +
        //        d + vp.num + '" name="vp_chk_r_' + d + vp.num + '" value="1" />' +
        //        '<label class="checkbox" for="f_vp_chk_r_' + d + vp.num +
        //        '"><span class="checkbox"></span></label></div><div class="d4lbl_r">' +
        //        vp.vp_fullname + '</div>';
        return t0[0];
    }

};
